import { useState, useEffect } from "react";


export function RegisterPage2({ setPage, errors, userData, setUserData }) {

  const handleRegister = () => {
    setPage(3);
  }

  const[usernameMissing, setUsernameMissing] = useState();
  const[usernameTaken, setUsernameTaken] = useState();
  const[pass1Missing, setPass1Missing] = useState();
  const[pass2Missing, setPass2Missing] = useState();


  useEffect(() => {
    if (errors.usernameMissing) {
      setUsernameTaken("El nombre de usuario es obligatorio");
    } else {
      setUsernameTaken("");
    }
  }, [errors.usernameMissing]);

  useEffect(() => {
    if (errors.usernameTaken) {
      setUsernameTaken("El nombre de usuario está en uso");
    } else {
      setUsernameTaken("");
    }
  }, [errors.usernameTaken]);

  useEffect(() => {
    if (errors.pass1Missing) {
      setPass1Missing("El password es obligatorio");
    } else {
      setPass1Missing("");
    }
  }, [errors.pass1Missing]);

  useEffect(() => {
    if (errors.passwordMatch){
      setPass1Missing("Las contraseñas no coinciden");
    } else {
      setPass1Missing("");
    }}, [errors.passwordMatch]);



  const handleUsernameChange = (event) => {
    const newName = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      username: newName,
    }));
  };

  const handlePassword1Change = (event) => {
    const newName = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      password1: newName,
    }));
  };

  const handlePassword2Change = (event) => {
    const newName = event.target.value;

    setUserData((prevUser) => ({
      ...prevUser,  
      password2: newName,
    }));
  };
  

  return (
    <>
      <div className="m-frmGroup">
        Nombre de usuario
        <div className="m-frmGroup is-error">
          <div id="username_missing" className="a-msg " >
            {usernameMissing}
          </div>
        </div>
        <div className="m-frmGroup is-error">
          <div id="username_taken" className="a-msg " >
            {usernameTaken}
          </div>
        </div> 
        <input 
          type="text" 
          name="username" 
          id="username" 
          placeholder="Escribe tu nombre de usuario" 
          required="required" 
          value={userData.username}
          onChange={handleUsernameChange}
        />
      </div>
                        
      <div className="m-frmGroup">
        Contraseña
      <div className="m-frmGroup is-error">
        <div id="pass1_missing" className="a-msg " >
          {pass1Missing}
        </div>
      </div> 
                            
      <input 
        type="password" 
        name="pass1" 
        id="pass1" 
        placeholder="Introduce tu contraseña" 
        required="required"
        value={userData.password1}
        onChange={handlePassword1Change}
      />
                            
    </div>
                        
    <div className="m-frmGroup">
      Repite tu contraseña
      <div className="m-frmGroup is-error">
        <div id="pass2_missing" className="a-msg ">
          {pass2Missing}
        </div>
      </div> 
                
      <input 
        type="password" 
        name="pass2" 
        id="pass2" 
        placeholder="Repite tu contraseña" 
        required="required"
        value={userData.password2}
        onChange={handlePassword2Change}
      />                           
    </div>
                        
    <br/>

    <div className="row content-flex-end">                           
      <div className="btnBlue-l btnArrow-l float-right"  onClick={() => handleRegister()} >Seguir</div>
    </div>
    </>
  );
}